export class DocumentMaster {
  constructor(
    public id?: number,
    public fileId?: number,
    public title?: string,
    public description?: string,
    public filename?: string,
    public size?: number,
    public sizeString?: string,
    public fileExtension?: string,
    public mimeType?: string,
    public createdBy?: string,
    public created?: Date,
    public lastUpdate?: Date,
    public lastUpdateBy?: string,
    public documentClassification?: string
  ) {}
  [key: string]: any;
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/document/models/document-master.ts